import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Address, Assignment, Contact } from '@apaq/orgkit-js';
import { addMinutes } from 'date-fns';

@Component({
  selector: '[ws-assignment-list-item]',
  templateUrl: './assignment-list-item.component.html',
  styleUrls: ['./assignment-list-item.component.scss']
})
export class AssignmentListItemComponent {

  @Input() layout = 'Contact';
  @Input() assignment?: Assignment;
  @Input() selectable = false;
  @Output() selectedChange = new EventEmitter<boolean>()
  _selected = false;

  get hasDeliveryAddress() {
    const deliveryAddress = (this.assignment as any).deliveryAddress as Address;
    return deliveryAddress != null && deliveryAddress.street != null && deliveryAddress.city != null && deliveryAddress.countryCode != null;
  }

  get currency() {
    return 'DKK';/*
    if (this.contextService.organization != null) {
      return this.contextService.organization.baseCurrency;
    } else {
      return 'DKK';
    }*/
  }

  get total() {
    let result = 0;
    this.assignment?.tasks.forEach(t => result += t.quantity * t.unitPrice);
    return result;
  }

  get selected() {
    return this._selected;
  }

  set selected(value: boolean) {
    if(value != this._selected) {
      this._selected = value;
      this.selectedChange.emit(value);
    }
  }

  get duration() {
    let duration = 0;
    this.assignment!.tasks.forEach(t => duration += t.duration);
    return duration;
  }

  get description() {
    let description = '';
    this.assignment!.tasks.forEach(t => {
      if (description !== '') {
        description += ', ';
      }
      description += t.description;
    });

    return description;
  }

  get startTime(): Date {
    if (this.assignment!.plan.specificStartTime) {
      return this.assignment!.plan.serviceWindow.startTime;
    } else {
      return this.assignment!.plan.executionTime;
    }
  }

  get endTime(): Date {
      return addMinutes(this.startTime, this.duration);
  }

  hasServiceWindow() {
    let window = null;
    if (this.assignment!.plan.serviceWindow != null) {
        window = this.assignment!.plan.serviceWindow;
    }
    if (window != null) {
        if (window.startTime.getHours() > 0 ||
            window.startTime.getMinutes() > 0 ||
            window.endTime.getHours() < 23 ||
            window.endTime.getMinutes() < 59) {
            return true;
        }
    }
    return false;
  }

  hasOrderStatus() {
    return this.assignment?.status !== 'None' && this.assignment?.status !== 'NotInvoiced';
  }

  get statusText() {
    switch(this.assignment!.status) {
      case 'AppendedToOrder':
      return $localize`Appended to order`;
    case 'AwaitingInvoicing':
      return $localize`Awaiting invoicing`;
    case 'Fulfilled':
      return $localize`Fulfilled`;
    case 'Invoiced':
      return $localize`Invoiced`;
    default:
      return '';
    }
  }

  get statusIconName() {
    switch(this.assignment!.status) {
      case 'AppendedToOrder':
      return 'file-text';
    case 'AwaitingInvoicing':
      return 'file-earmark-text';
    case 'Fulfilled':
      return 'file-check';
    case 'Invoiced':
      return 'file-earmark-check';
    default:
      return '';
    }
  }


}
